import { useState } from "react";
import SupportOnboardingModal from "./SupportOnboardingModal";
import { useHistory } from "react-router-dom";

export default function SupportTips() {
    const [showModal, setShowModal] = useState(true);
    const history = useHistory();

    const handleModalClose = () => {
        setShowModal(false);
        history.push(`${process.env.PUBLIC_URL}/support/support-dashboard`);
    };

    const handleFinish = () => {
        setShowModal(false);
        history.push(`${process.env.PUBLIC_URL}/support/support-dashboard`);
    };

    return (
        <div className="container p-0">
            <SupportOnboardingModal
                show={showModal}
                onHide={handleModalClose}
                onFinish={handleFinish}
            />
        </div>
    );
}
